import React from "react";
import splitArrayRole from "./utils/splitArrayRole";

const setSplitAlignment = (text_alignment) => {
  switch (text_alignment) {
    case "left":
      return [" text-left ", " text-left "];
    case "justify":
      return [" text-left ", " text-right "];
    case "right":
      return [" text-right ", " text-right "];
    case "gutter":
      return [" text-right ", " text-left "];
    default:
      return [" text-right ", " text-left "];
  }
};

const getAlignment = (text_alignment, columns) => {
  switch (text_alignment) {
    case "left":
      return Array(columns).fill(" text-start ");
    case "justify":
      if (columns === 2) return [" text-start ", " text-end "];
      if (columns === 3) return [" text-start ", " text-center ", " text-end "];
      return [" text-start ", " text-end "];
    case "right":
      return Array(columns).fill(" text-end ");
    case "center":
      return Array(columns).fill(" text-center ");
    default:
      return Array(columns).fill(" text-end ");
  }
};

const getPadding = (textAlignment, noOfCols, colIdx, gutter) => {
  let pl = 0;
  let pr = 0;
  if (textAlignment === "gutter") {
    if (noOfCols === 2) {
      if (colIdx === 0) pr = gutter;
      if (colIdx === 1) pl = gutter;
    }
    if (noOfCols === 4) {
      if (colIdx === 1) pr = gutter;
      if (colIdx === 2) pl = gutter;
    }
  }
  return {
    paddingLeft: `${pl}px`,
    paddingRight: `${pr}px`,
  };
};

export default function RoleName2({ items, options, fontStyle, settings }) {
  const roleCount = items.filter((item) => item.role);

  const arraySplitDataByRole = options?.double_columns
    ? splitArrayRole(items, options).ans
    : [];

  // ==========================================================================================

  const arraySplitData = options?.double_columns
    ? []
    : splitArrayRole(items, options).ans;
  const textAlignment = getAlignment(options?.text_alignment, options?.columns);

  const { textDecoration: ___, ...roleStyle } = fontStyle.role;
  const { textDecoration: ____, ...nameStyle } = fontStyle.name;

  const marginBottom =
    Math.max(fontStyle.role.fontSize, fontStyle.name.fontSize) *
      fontStyle?.role?.lineHeight -
    Math.max(fontStyle.role.fontSize, fontStyle.name.fontSize) * 1.2;

  const trStyle = {
    display: "flex",
    justifyContent: "center",
    // alignItems: "baseline",
    alignItems:'flex-end',
    // alignItems:  options.text_alignment === "left" ? "flex-start" : options.text_alignment === "right" ? "flex-end" : "baseline",
    // width: `${options.column_width}%`,
    width: "100%",
    margin: "0 auto",
    verticalAlign: "text-bottom",
    // marginBottom: `${marginBottom}px`,
    // lineHeight: fontStyle?.role?.lineHeight + 0.2,
    wordBreak: "break-word",
    paddingLeft: "10px",
    paddingRight: "10px",
    flexWrap: options.columns > 1 ? "wrap" : "nowrap",
    // minWidth: "200px", // Ensure a minimum width to avoid wrapping issues
  };

  const tdStyleRight = {
    width: "50%",
    textAlign: "right",
    paddingRight: `${settings.gutter}px`,
    verticalAlign: "text-bottom",
    ...(options.name_on_left ? nameStyle : roleStyle),
    height: "min-content",
    fontKerning: "none",
    fontFeatureSettings: '"kern" 0',
    textRendering: "geometricPrecision",
    WebkitFontSmoothing: "antialiased",
    alignSelf:'flex-end',
    lineHeight: options.name_on_left ? fontStyle?.name?.lineHeight + 0.2 : fontStyle?.role?.lineHeight + 0.2
  };

  const tdStyleLeft = {
    width: "50%",
    textAlign: "left",
    paddingLeft: `${settings.gutter}px`,
    verticalAlign: "text-bottom",
    ...(options.name_on_left ? roleStyle : nameStyle),
    height: "min-content",
    fontKerning: "none",
    fontFeatureSettings: '"kern" 0',
    textRendering: "geometricPrecision",
    WebkitFontSmoothing: "antialiased",
    alignSelf:'flex-end',
    lineHeight: options.name_on_left ? fontStyle?.role?.lineHeight + 0.2 : fontStyle?.name?.lineHeight + 0.2
  };

  const tdStyleRightColumn = {
    textAlign: "right",
    paddingRight: `${settings?.ragged_gutter / 2}px`,
    verticalAlign: "text-bottom",
    ...(options.name_on_left ? nameStyle : roleStyle),
    height: "min-content",
    fontKerning: "none",
    fontFeatureSettings: '"kern" 0',
    textRendering: "geometricPrecision",
    WebkitFontSmoothing: "antialiased",
    alignSelf:'flex-end',
    lineHeight: options.name_on_left ? fontStyle?.name?.lineHeight +  0.2 : fontStyle?.role?.lineHeight + 0.2
  };

  const tdStyleLeftColumn = {
    textAlign: "left",
    paddingLeft: `${settings.ragged_gutter / 2}px`,
    verticalAlign: "text-bottom",
    ...(options.name_on_left ? roleStyle : nameStyle),
    height: "min-content",
    fontKerning: "none",
    fontFeatureSettings: '"kern" 0',
    textRendering: "geometricPrecision",
    WebkitFontSmoothing: "antialiased",
    alignSelf:'flex-end',
    lineHeight: options.name_on_left ? fontStyle?.role?.lineHeight + 0.2 : fontStyle?.name?.lineHeight + 0.2
  };

  return options.double_columns ? (
    options.text_alignment === "ragged" ? (
      // Double Column (Ragged Align)

      <div
        className={`flex flex-row flex-wrap ${
          options?.columns === 1 ? "justify-center" : ""
        } 
        ${options?.text_alignment === "gutter" ? " justify-center " : ""}`}
        style={{
          width: `${options.column_width * options.columns}%`,
          margin: "0 auto",
          wordBreak: "break-word",
        }}
      >
        {arraySplitDataByRole?.map((items, index) => (
          <div
            key={index}
            className={`flex flex-col flex-1 break-words float-left`}
            style={{ width: `${options.column_width}%` }}
          >
            {items?.map((item, index) => {
              return (
                <div key={index} className="roleName_tr" style={trStyle}>
                  <div
                    className="roleName_td FontSIzeScale"
                    style={tdStyleRightColumn}
                  >
                    <span
                      style={{
                        textDecoration: options.name_on_left
                          ? fontStyle.name.textDecoration
                          : item.role == null
                          ? "none"
                          : fontStyle.role.textDecoration,
                        color: options.name_on_left
                          ? ""
                          : item.role == null
                          ? "transparent"
                          : fontStyle.role.color,
                      }}
                    >
                      {options.name_on_left
                        ? item.name
                        : item.role == null
                        ? ". "
                        : item.role}
                    </span>
                  </div>
                  <div
                    className="roleName_td FontSIzeScale"
                    style={tdStyleLeftColumn}
                  >
                    <span
                      style={{
                        textDecoration: options.name_on_left
                          ? item.role == null
                            ? "none"
                            : fontStyle.role.textDecoration
                          : fontStyle.name.textDecoration,
                        color: options.name_on_left
                          ? item.role == null
                            ? "transparent"
                            : fontStyle.role.color
                          : "",
                      }}
                    >
                      {options.name_on_left
                        ? item.role == null
                          ? " ."
                          : item.role
                        : item.name}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    ) : (
      // Double Column (Gutter Align/Left/Right/Justify Align)

      <div
        className={`flex flex-row flex-wrap ${
          options?.columns === 1 ? "justify-center" : ""
        } 
        ${options?.text_alignment === "gutter" ? " justify-center " : ""}`}
        style={{
          width: `${options.column_width * options.columns}%`,
          margin: "0 auto",
          wordBreak: "break-word",
        }}
      >
        {arraySplitDataByRole?.map((items, index) => (
          <div
            key={index}
            className={`flex flex-col flex-1 break-words float-left`}
            style={{ width: `${options.column_width}%` }}
          >
            {items.map((item, index) => {
              return (
                <div key={index} className="roleName_tr" style={trStyle}>
                  <div
                    style={tdStyleRight}
                    className="roleName_td FontSIzeScale"
                  >
                    <span
                      className={`inline-block w-full span1 ${
                        setSplitAlignment(options.text_alignment)[0]
                      }`}
                      style={{
                        textDecoration: options.name_on_left
                          ? fontStyle.name.textDecoration
                          : item.role == null
                          ? "none"
                          : fontStyle.role.textDecoration,
                        color: options.name_on_left
                          ? ""
                          : item.role == null
                          ? "transparent"
                          : fontStyle.role.color,
                        fontFamily: options.name_on_left
                          ? fontStyle.name.fontFamily
                          : fontStyle.role.fontFamily,
                        // backgroundColor:'gray'
                      }}
                    >
                      {options.name_on_left
                        ? item.name
                        : item.role == null
                        ? "No Roll"
                        : item.role}
                    </span>
                  </div>
                  <div
                    style={tdStyleLeft}
                    className="roleName_td FontSIzeScale"
                  >
                    <span
                      className={`inline-block w-full span2 ${
                        setSplitAlignment(options.text_alignment)[1]
                      }`}
                      style={{
                        textDecoration: options.name_on_left
                          ? item.role == null
                            ? "none"
                            : fontStyle.role.textDecoration
                          : fontStyle.name.textDecoration,
                        color: options.name_on_left
                          ? item.role == null
                            ? "transparent"
                            : fontStyle.role.color
                          : "",
                        fontFamily: options.name_on_left
                          ? fontStyle.role.fontFamily
                          : fontStyle.name.fontFamily,
                      }}
                    >
                      {options.name_on_left
                        ? item.role == null
                          ? "No Roll"
                          : item.role
                        : item.name}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    )
  ) : (
    // Single Column (Gutter Align)

    <div
      className={`flex flex-row flex-wrap ${
        options?.columns === 1 ? "justify-center" : ""
      } 
      ${options?.text_alignment === "gutter" ? " justify-center " : ""}`}
      style={{
        width: `${options.column_width * options.columns}%`,
        margin: "0 auto",
        wordBreak: "break-word",
        justifyContent:
          options.text_alignment === "left"
            ? "flex-start"
            : options.text_alignment === "right"
            ? "flex-end"
            : "center",
      }}
    >
      {arraySplitData?.map((items, index) => (
        <div
          key={index}
          className={`flex flex-col flex-1 break-words float-left`}
        >
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col`}
              style={{
                alignItems:
                  options.text_alignment === "left"
                    ? "flex-start"
                    : options.text_alignment === "right"
                    ? "flex-end"
                    : "center",
              }}
            >
              <span
                className={
                  options.name_on_left
                    ? " order-1 FontSIzeScale"
                    : " order-0 FontSIzeScale"
                }
                style={{
                  ...roleStyle,
                  textDecoration:
                    item.role == null ? "none" : fontStyle.role.textDecoration,
                  color:
                    item.role == null ? "transparent" : fontStyle.role.color,
                  lineHeight:
                    item.role == null
                      ? "0"
                      : fontStyle?.role?.lineHeight + 0.12,
                  paddingLeft: "1px",
                  paddingRight: "1px",
                }}
              >
                {item.role == null ? "No Roll" : item.role}
              </span>
              <span
                className={
                  options.name_on_left
                    ? " order-0 FontSIzeScale"
                    : " order-1 FontSIzeScale"
                }
                style={{
                  ...nameStyle,
                  textDecoration: fontStyle.name.textDecoration,
                  color:
                    item.name == null ? "transparent" : fontStyle.name.color,
                  lineHeight:
                    item.name == null
                      ? "0"
                      : fontStyle?.name?.lineHeight + 0.12,
                  paddingLeft: "1px",
                  paddingRight: "1px",
                }}
              >
                {item.name == null ? "No Roll" : item.name}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
